import * as licenceApi from '../services/api/licence';
import {SubmissionError} from "redux-form";

export const LICENCE_RECEIVED = 'LICENCE_RECEIVED';
export const LICENCES_RECEIVED = 'LICENCES_RECEIVED';

export function licencesReceived(licences) {
    return {
        type: LICENCES_RECEIVED,
        licences
    }
}

export function createLicence(params) {

    return () => {

        return licenceApi
            .create(params)
            .catch(res => { throw new SubmissionError(res.payload) });
    }
}

export function refreshAllLicences() {

    return dispatch => {

        licenceApi
            .getAll()
            .then(res => dispatch(licencesReceived(res.payload)));
    }
}

export function refreshLicence(id) {
    return dispatch => {
        return licenceApi
            .getOne(id)
            .then(res => dispatch(licenceRefreshed(res.payload)));
    }
}

export function refreshServiceLicence(serviceId, licenceType) {
    return dispatch => {
        return licenceApi
            .getServiceLicence(serviceId, licenceType)
            .then(res => dispatch(licenceRefreshed(res.payload)));
    }
}

export function licenceRefreshed(licence) {
    return {
        type: LICENCE_RECEIVED,
        licence
    }
}

export function updateLicence(licence) {

    return dispatch => {
        return licenceApi
            .update(licence)
            .then(res => {
                dispatch(licenceRefreshed(res.payload));
                return res.payload;
            })
            .catch(res => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                })
            });
    }
}

export function deleteLicence(licenceId) {

    return dispatch => {
        return licenceApi
            .remove(licenceId)
            .then(() => dispatch(refreshAllLicences()));
    }
}